/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'staff': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs><path pid="0" id="svgicon_staff_a" d="M0 0h20v20H0z"/></defs><g _fill="none" fill-rule="evenodd"><mask id="svgicon_staff_b" _fill="#fff"><use xlink:href="#svgicon_staff_a"/></mask><path pid="1" d="M15.79 2.549c1.11 0 2.01.9 2.01 2.01h0v13.34H2.12v-8.64c0-1.01.82-1.83 1.83-1.83h2.9v-2.87c0-1.11.9-2.01 2.01-2.01h0zm.005 1.172h-6.94c-.46 0-.83.37-.83.83v12.18h1.7v-2.44c0-.76.62-1.37 1.38-1.37h2.44c.76 0 1.38.61 1.38 1.37v2.44h1.7V4.55c0-.46-.37-.83-.83-.83zM6.85 8.596h-2.9c-.36 0-.66.3-.66.66v7.47h3.56v-8.13zm6.697 5.492h-2.44c-.12 0-.21.09-.21.21v2.42h2.86v-2.42c0-.12-.1-.21-.21-.21zm.883-4.727c.32 0 .58.26.58.59 0 .32-.26.58-.58.58h0-4.2c-.33 0-.59-.26-.59-.58 0-.33.26-.59.58-.59h0zm0-3.191c.32 0 .58.26.58.59 0 .32-.26.58-.58.58h0-4.2c-.33 0-.59-.26-.59-.58 0-.33.26-.59.58-.59h0z" _stroke="#FFF" stroke-width=".3" _fill="#FFF" stroke-dasharray="0,0" mask="url(#svgicon_staff_b)"/></g>'
  }
})
